<header class="masthead" style="background-image: url('assets/img/test-background.png')">
    <div class="overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-10 mx-auto">
                <div class="page-heading">
                    <h1 style="color:white;">About Me</h1>
                    <span style="color:white;" class="subheading">This is what I do.</span>
                </div>
            </div>
        </div>
    </div>
</header>

<div class="container">
    <div class="row">
        <div class="col-md-4">
            <img src="assets/img/me.jpg" class="img-fluid" />
        </div>
        <div class="col-md-8">

            <p style="font-size:17px;line-height:1.8rem;color:#252525;">
                My name is Duy Lan Le, and I'm a Fullstack Angular + .NET Developer. 
                I made this Blog's site by using Angular and ASP .NET MVC with PostgresSQL as my Database. 
                I host this website on Netlify because it's... free :).</p>
            <p style="font-size:17px;line-height:1.8rem;color:#252525;">
                This is my first project using Angular and ASP .NET MVC and I learn a lot from this project. 
                In this website, I can write my own blog and attach Image in to it. 
                It has authentication, authorization, and a comment system. 
                Thus, you can register an account in my website by using your
                 email or you can use other method like Google, 
                 Facebook, Github, or Twitter (but I think it's broken now :((  ).</p>
            <p style="font-size:17px;line-height:1.8rem;color:#252525;">You can comment and having fun with my blog, and if you want, you can contact me through a contact tab on the navigation bar, or you can have a short look at my portfolio if you want to hire me as your employee :).</p>
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="more-info">
                        <ul class="list-ico">
                            <li><a target="_blank" style="color:#1cd5db;" href="https://duylanle-portfolio.netlify.app/"><h5><span class="iconify" data-icon="ant-design:folder-filled" data-inline="true"></span> My Portfolio</h5></a></li>
                            <li><span class="ion-ios-location"></span>Lincoln, NE 68502</li>
                            <li><span class="ion-ios-telephone"></span> (402)-304-0329</li>
                            <li><a href="mailto:arthastheking113@gmail.com"><span class="ion-email"></span> arthastheking113@gmail.com</a></li>
                        </ul>
                    </div>
                    <div class="socials">
                        <ul>
                            <li class="p-1"><a target=”_blank” href="https://github.com/arthastheking113"><span class="ico-circle"><span class="iconify" data-icon="akar-icons:github-fill" data-inline="true"></span></span></a></li>
                            <li class="p-1"><a target="_blank" href="https://www.linkedin.com/in/duy-lan-le-445262163/"><span class="ico-circle"><span class="iconify" data-icon="entypo-social:linkedin-with-circle" data-inline="true"></span></span></a></li>
                            <li class="p-1"><a target="_blank" href="https://twitter.com/DuyLanLe3"><span class="ico-circle"><span class="iconify" data-icon="akar-icons:twitter-fill" data-inline="true"></span></span></a></li>
                            <li class="p-1"><a target="_blank" href="https://www.instagram.com/duylanle97/"><span class="ico-circle"><span class="iconify" data-icon="ant-design:instagram-filled" data-inline="true"></span></span></a></li>
                        </ul>
                    </div>
                </div>
        </div>
    </div>
</div>






